export const scrollTo = (target, timeout) => {
  if (target == undefined || target == null) return
  let position =
      typeof target === 'number'
        ? target
        : getPos(document.getElementById(target)).top,
    scrollTop = document.documentElement.scrollTop || document.body.scrollTop,
    direction = position - scrollTop > 0 ? 1 : -1,
    distance = Math.abs(position - scrollTop),
    split = distance / 50,
    _timeout
  if (position !== scrollTop) {
    timeout = timeout || 1000
    split *= direction
    _timeout = setInterval(function() {
      scrollTop += split
      distance -= Math.abs(split)
      if (0 >= distance) {
        window.scrollTo(0, position)
        clearInterval(_timeout)
        _timeout = null
      } else {
        window.scrollTo(0, scrollTop)
      }
    }, timeout / 100)
  }
}

export const getPos = obj => {
  const oPos = {
    left: 0,
    top: 0,
  }
  while (obj) {
    oPos.left += obj.offsetLeft
    oPos.top += obj.offsetTop
    obj = obj.offsetParent
  }
  return oPos
}
